import { render, staticRenderFns } from "./YSPlayerControl.vue?vue&type=template&id=66723bfd"
import script from "./YSPlayerControl.vue?vue&type=script&lang=js"
export * from "./YSPlayerControl.vue?vue&type=script&lang=js"
import style0 from "./YSPlayerControl.vue?vue&type=style&index=0&id=66723bfd&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports